var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "listing-settings" },
    [
      _c(
        "CompassTooltip",
        { attrs: { content: _vm.title, arrow: false } },
        [
          _c("CompassIconButton", {
            staticClass: "listing-settings__button",
            attrs: { icon: "settings" },
            on: { click: _vm.openDialog }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "CompassDialog",
        {
          attrs: {
            title: _vm.title,
            primaryAction: _vm.primaryAction,
            secondaryActions: _vm.secondaryActions,
            visible: _vm.displaySettingsDialog,
            size: "small"
          },
          on: { "update:visible": _vm.closeDialog }
        },
        [
          _c("ListingSettingsColumn", {
            ref: "listingSettingsColumn",
            attrs: {
              columns: _vm.newSettings.columns,
              searchable: _vm.searchableColumns
            },
            on: {
              updateColumns: function(columns) {
                _vm.newSettings.columns = columns
              }
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }